var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.styleClasses,attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[((_vm.selfGuard || _vm.noGuard) && _vm.isWaiting)?_c('div',{class:_vm.spinnerClasses},[_c('span',{class:_vm.spanClasses})]):_vm._e(),_vm._v("\n  "+_vm._s(_vm.btnLabel)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dbffecb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/SquaredButton.vue
// module id = null
// module chunks = 